import React, { useState, useRef, useEffect } from "react";

const GenerateSection = ({forms, setForms, isAdvOpen, setIsAdvOpen, 
errorsActivated, setErrorsActivated, textareaRef, addDepsRef, copiedRef, errorsRef, displayErrors, scrollToTarget}) => {
  
  let manifest =
  {
    format_version: 2,
    header: {
      name: 'Name here',
      description: '',
      uuid: 'f601088e-74b0-4324-8475-d242b2613967',
      version: [
         1,
         0,
         0
      ],
      min_engine_version: [
        1,
        21,
        7
      ]
    },
    modules: [
      {
        description: '',
        type: 'data',
        uuid: 'f601088e-74b0-4324-8475-d242b2613967',
        version: [
          1,
          0,
          0
        ]
      }
    ],
    dependencies: [
      {
        description: '',
        type: 'data',
        uuid: 'f601088e-74b0-4324-8475-d242b2613967',
        version: [
          1,
          0,
          0
        ]
      }
    ],
    metadata: {
      authors: [
        ''
      ],
      url: '',
      product_type: 'addon'
    }
  };
  
  const [generateClicked, setGenerateClicked] = useState(false);
  
  const generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
          v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  };
  
  const inputOption = (opt) => {
    if (opt === 'opt-1') {
      return 'resources';
    } else if (opt === 'opt-2') {
      return 'data';
    } else if (opt === 'opt-3') {
      return 'skin_pack';
    }
  };
  
  const inputVersion = (version) => {
    const vArr = version.split('.');
    
    return [Number(vArr[0]), Number(vArr[1]), Number(vArr[2])];
      
  };
  
  const formatManifest = (jsonString) => {
      try {
        const jsonObject = JSON.parse(jsonString);
        const formattedJsonString = JSON.stringify(jsonObject, null, 2); // Indentation of 2 spaces
        return formattedJsonString;
      } catch (error) {
        console.error("Error parsing or formatting JSON:", error.message);
        return null;
      }
    };
  
  const renderManifestJson = () => {
    const escapedName = forms[0].name.replace(/"/g, '\\"');
    const escapedDesc = forms[0].description.replace(/"/g, '\\"');
    
    const filtered = forms.filter((form) => form.type === 'dependency');
    const deps = filtered.map((dep) => {
      return {
        type: inputOption(dep.selectedOpt),
        uuid: dep.uuid,
        version: inputVersion(dep.version),
        description: dep.description
      };
    });

    manifest.header.name = escapedName;
    manifest.header.uuid = generateUUID();
    manifest.header.version = inputVersion(forms[0].version);
    if (forms[0].selectedOpt === 'opt-3') {
      delete manifest.header.min_engine_version;
    }
    manifest.header.description = escapedDesc;

    manifest.modules[0].type = inputOption(forms[0].selectedOpt);
    manifest.modules[0].uuid = generateUUID();
    manifest.modules[0].version = inputVersion(forms[0].version);
    manifest.modules[0].description = escapedDesc; 

    //has no dependency
    if (filtered.length === 0) {
      delete manifest.dependencies;
    } else {
      manifest.dependencies = deps;
    }

    //has no metadata
    const isBehaviorPack = forms[0].selectedOpt === 'opt-2';
    const hasMetadataFields = forms[1].name !== '' || forms[1].link !== '';
    if (!isBehaviorPack && !hasMetadataFields) {
      delete manifest.metadata;
    } else {
      manifest.metadata = {};
      if (hasMetadataFields) {
        manifest.metadata.authors = [];
        manifest.metadata.authors[0] = forms[1].name;
        manifest.metadata.url = forms[1].link;
      }
      if (isBehaviorPack) {
        manifest.metadata.product_type = 'addon';
      }
    }

    const jsonString = JSON.stringify(manifest);

    const formattedManifest = formatManifest(jsonString);
    textareaRef.current.value = formattedManifest;
};

  const handleCopyToClipboard = () => {
    //if textarea contains json string
    if (textareaRef.current.value) {
      const textToCopy = textareaRef.current.value;
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          copiedRef.current.style.display = 'block';
          setTimeout(() => {
            copiedRef.current.style.display = 'none';
          }, 2000);
        })
        .catch((error) => {
          console.error('Error copying text:', error);
        });
    }
  };
  
  const handleDownload = () => {
    const jsonText = textareaRef.current.value;
    if (jsonText) {
      const jsonBlob = new Blob([jsonText], { type: 'application/json' });
      const url = URL.createObjectURL(jsonBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'manifest.json');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  
  
  useEffect(() => {
    const hasErrors = displayErrors() !== null;

    if (!hasErrors) {
      renderManifestJson();
      setErrorsActivated(false);
    }
  }, [generateClicked]); 
  
  
  
  return (
    <section className="container generate-section">
       <div className="button-container">
        <div className="mc-button mc-btn-gr" 
         onClick={() => {
          setErrorsActivated(true);
          setGenerateClicked(!generateClicked);
         }}>
          <div className="mc-btn-con">
            <p>Generate</p>
          </div>
        </div>
       </div>

       <div ref={errorsRef} className="missing">
        {errorsActivated && displayErrors()}
       </div>
       <p className="heading manifest-json-txt">MANIFEST.JSON</p>
       <textarea disabled ref={textareaRef} placeholder="Generate..."></textarea>

       <div className="button-container">
        <div className="mc-button mc-btn-wh" onClick={() => {
         handleCopyToClipboard();
        }}>
          <div className="mc-btn-con">
            <p>Copy</p>
          </div>
        </div>
       </div>

       <div className="button-container">
        <div className="mc-button mc-btn-wh" onClick={handleDownload}>
          <div className="mc-btn-con">
            <p>Download</p>
          </div>
        </div>
       </div>
    </section>
  );
}

export default GenerateSection;
